import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["front", "back", "trigger", "return"]

  show(event) {
    event.preventDefault()
    event.stopPropagation()
    this.setFlipped(true)
    this.returnTarget.focus({ preventScroll: true })
  }

  hide(event) {
    if (!this.element.classList.contains("is-flipped")) return
    event?.preventDefault()
    event?.stopPropagation()
    this.setFlipped(false)
    this.triggerTarget.focus({ preventScroll: true })
  }

  reset() {
    this.setFlipped(false)
  }

  stop(event) {
    event.stopPropagation()
  }

  setFlipped(flipped) {
    this.element.classList.toggle("is-flipped", flipped)
    this.frontTarget.inert = flipped
    this.frontTarget.setAttribute("aria-hidden", String(flipped))
    this.backTarget.inert = !flipped
    this.backTarget.setAttribute("aria-hidden", String(!flipped))
    this.triggerTarget.setAttribute("aria-expanded", String(flipped))
  }
}
